import { useState, useEffect, useCallback } from 'react';
import { getProgressionSuggestions, ProgressionSuggestion } from '@/lib/auto-progression';

export function useProgressionSuggestions(clientId: string | undefined) {
  const [suggestions, setSuggestions] = useState<ProgressionSuggestion[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const loadSuggestions = useCallback(async () => {
    if (!clientId) {
      setSuggestions([]);
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const data = await getProgressionSuggestions(clientId);
      setSuggestions(data);
    } catch (err) {
      console.error('Error loading progression suggestions:', err);
      setError('Failed to load progression suggestions');
    } finally {
      setLoading(false);
    }
  }, [clientId]);

  useEffect(() => {
    loadSuggestions();
  }, [loadSuggestions]);

  const dismissSuggestion = useCallback((exerciseId: string) => {
    setSuggestions(prev => prev.filter(s => s.exerciseId !== exerciseId));
  }, []);

  return {
    suggestions,
    loading,
    error,
    reload: loadSuggestions,
    dismissSuggestion,
  };
}
